export * from './customer-add';
export * from './customer-edit';
export * from './customer-detail';
export * from './customer-summary';
export * from './customer-routing.module';
export * from './customer.module';



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/customer/index.ts